<vue-page-header appName="{{ 'title.applicationName' | translate | async }}"
  navSection="{{ 'title.alerts' | translate | async }}" [enableBack]="true"
 ></vue-page-header>
<app-page-body>
  <vue-section-header class="details-header-wrapper">
    <h2 class="details-header-text">{{ "title.configurationDetails" | translate | async }}</h2>
    <app-underutilization-edit-drawer [underutilizationedit]="sourceData" ></app-underutilization-edit-drawer>
  </vue-section-header>

  <vue-section [loading]="pageLoading">
  <div class="wrapper">
    <div>
        <h3>Alert Condition</h3>
         <div class="detail-column-section">
          <vue-detail-header>DAYS TO CHECK</vue-detail-header>
          <vue-detail-content>{{this.sourceData?.daysToCheck}}</vue-detail-content>
             <vue-detail-header>0=Today</vue-detail-header>
            <vue-detail-header>1=Tommorow and so on</vue-detail-header>
            <div style="padding-top: 50px;">
                 <vue-detail-header>TIME CONFIGURATION(UTC)</vue-detail-header>
                   <vue-detail-content *ngIf="this.sourceData?.isPerDay">Per day</vue-detail-content>
                   <span *ngIf="this.sourceData?.isPerDay">
                             <vue-detail-content *ngFor=" let data of this.sourceData?.alertSchedule?.perDay">
                    {{data.startTime}}-{{data.endTime}}</vue-detail-content>
                   </span>
          

                    <vue-detail-content *ngIf="this.sourceData?.isHourly">Consecutive hourly intervals</vue-detail-content>
                   <vue-detail-content *ngIf="this.sourceData?.isHourly"></vue-detail-content>
            </div>
           
          
        </div>
    </div>
    <div>
        
        <h3>Utilization Evaluation</h3>
         <div class="detail-column-section">
          <vue-detail-header>EXECUTION TIME</vue-detail-header>
          <vue-detail-content>{{this.sourceData?.runFrequency.runTime}}(UTC)</vue-detail-content>
          <vue-detail-header>Alert will be evaluated once per day at this time</vue-detail-header>
        </div>
         <div style="padding-top: 45px;">
                 <vue-detail-header>Queue</vue-detail-header>
                  <vue-detail-content>{{this.sourceData?.queueName}}</vue-detail-content>
            </div>
    </div>
    <div>
        <h3>Email</h3>
     <div class="detail-column-section">
          <vue-detail-header>EMAIL</vue-detail-header>
          <vue-detail-content>{{this.sourceData?.threshold?.email}}</vue-detail-content>
        </div>
         <div style="padding-top: 90px;">
           <vue-detail-header>STATUS</vue-detail-header>
    </div>
    </div> 
   
  </div>
  <div style="padding: 42px 25px 25px;
">
     <vue-detail-header>%(UTILIZATION THRESHOLD)</vue-detail-header>
       <vue-detail-content>{{this.sourceData?.threshold?.percentage}}%</vue-detail-content>
  </div>
 <div style="padding-left:25px; padding-bottom:25px">
     <vue-detail-content>Execution Summary:-</vue-detail-content>
     <vue-detail-header>{{this.sourceData?.execSummary}}
     </vue-detail-header>
 </div>
   
  </vue-section>
</app-page-body> 